import {stringWithoutNikud} from './commonHebrew'
import {BlankState} from '../store/stateChanges'

export function toUserDictionaryObjForm(wordList, negativeWordList) {
  let uDict = JSON.parse(JSON.stringify(BlankState.userDictionary))
  // console.log('JSON.stringify(uDict):')
  // console.log(JSON.stringify(uDict))
  wordList.forEach(word => {
    uDict.entryPresent[word] = true
    const withoutNikud = stringWithoutNikud(word)
    if (uDict.lettersMap[withoutNikud]) {
      uDict.lettersMap[withoutNikud].push(word)
    } else uDict.lettersMap[withoutNikud] = [word]
  })
  negativeWordList.forEach(word => {
    uDict.negativeEntryPresent[word] = true
    const withoutNikud = stringWithoutNikud(word)
    if (uDict.negativeLettersMap[withoutNikud]) {
      uDict.negativeLettersMap[withoutNikud].push(word)
    } else uDict.negativeLettersMap[withoutNikud] = [word]
  })
  return uDict
}
